import React, {useEffect, useMemo} from "react";
import {Avatar, Badge} from "@mui/material";
import {generateStaticColorFromUserId} from "../../utils";
import {gql, useSubscription} from "@apollo/client";
import {faCheck, faPhone, faPhoneVolume} from "@fortawesome/pro-solid-svg-icons";
import dayjs from "dayjs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const USERID_LAST_SEEN = gql`
subscription GetUser ($userId: uuid = "") {
  user(id: $userId) {
		id
		firstName
		lastName
		lastSeen
		image
		phoneState
		updatedAt
	} 
}
`;


// user= business.user hvis det er en "EMPLYEE"
// user= organizationUser hvis det er en "COMPANY" eller "CUSTOMER"
//initial brukes for breg results da de ikke har en bruker
// hvis det er en organisasjon så skal det være org.image first om ikke så 1 bokstav av org navn

const StaticAvatar = ({ user, userId, initial = null, sx = {}, badgeStyleProp = {}, phoneStateVisible = true, size = 36}) => {

	const {data, error} = useSubscription(USERID_LAST_SEEN, {
		skip: !user?.id && !userId,
		variables: {
			userId: userId ?? user?.id
		}
	});

	useEffect(() => {
		if (error) {
			console.error(error);
		}
	}, [error]);

	const lastSeen = useMemo(() =>
		data?.user ? dayjs(new Date()).diff(data?.user?.lastSeen ? data?.user?.lastSeen + "Z" : 0, "seconds") + 1 : 0,
	[data?.user]
	);

	const initials = user ? user?.role === "COMPANY" ? user?.firstName?.slice(0, 1) : user?.firstName?.slice(0, 1) + user?.lastName?.slice(0, 1) : initial;

	const staticBackgroundColor = generateStaticColorFromUserId(user?.id);
	const style = {
		width: size,
		height: size,
		marginRight: 1,
		backgroundColor: staticBackgroundColor,
		fontWeight: 500,
		color: "white",
		mr: 0,
		...sx
	};

	const phoneStateStyle = {
		BUSY: { icon: faPhone, color: "#ee4e4e" },
		ALERT: { icon: faPhoneVolume, color: "#e0ac50" },
		IDLE: { icon: faCheck, color: lastSeen <= 900 ? "#15a410" : lastSeen <= 86400 ? "#e0ac50" : "#c5c4c4"}
	};

	const badgeStyle = {
		"& .MuiBadge-badge": {
			background: phoneStateStyle[data?.user?.phoneState]?.color,
			height: size / 3,
			width: size / 3,
			minWidth: size / 3,
			padding: 0,
			borderRadius: "50%",
			border: data?.user?.phoneState !== null ?  "1px solid white" : "none",
			...badgeStyleProp
		}
	};

	const badgeIconStyle = {
		height: size / 6,
		width: size / 6
	};

	return (
		<Badge
			overlap="circular"
			anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
			// variant={image ? "dot" : "standard"}
			sx={(phoneStateVisible && lastSeen > 0) ? badgeStyle : {}}
			badgeContent={ data?.user?.phoneState !== "IDLE" && phoneStateStyle[data?.user?.phoneState]?.icon &&
					<FontAwesomeIcon icon={phoneStateStyle[data?.user?.phoneState]?.icon} color={"white"} style={badgeIconStyle}/>
			}
			invisible={!phoneStateVisible && lastSeen > 0}
		>
			{data?.user?.image ?
				<Avatar sx={style} src={data?.user?.image}/> :
				<Avatar sx={style} >{initials ?? null}</Avatar>}
		</Badge>
	);

};
export const StaticAvatarOrganization = ({ organization, sx = {}, size = 36}) => {
	const initial = organization?.name?.charAt(0)?.toUpperCase() ?? null;
	const img = organization?.image ?? null;
	const staticBackgroundColor = img ? null : generateStaticColorFromUserId(organization?.id);

	const style = {
		width: size,
		height: size,
		marginRight: 1,
		backgroundColor: staticBackgroundColor,
		fontWeight: 500,
		color: "white",
		...sx
	};

	return (
		<Avatar
			variant={"rounded"}
			sx={style}
			src={img}
		>
			{initial}
		</Avatar>
	// <Avatar sx={{backgroundColor: staticBackgroundColor, ...sx}} >{initial ?? null}</Avatar>
	);
};

export default StaticAvatar;
